import { PropsWithChildren } from 'react';
import { Header } from './Header';
import { BottomNavigation } from './BottomNavigation';
import './AppShell.css';

export const AppShell = ({ children }: PropsWithChildren) => {
  return (
    <div className="app-shell">
      <Header />
      <main className="app-shell__content">{children}</main>
      <BottomNavigation />
    </div>
  );
};
